import { render } from "./MailingEditComponent.vue?vue&type=template&id=2e51ae07&scoped=true"
import script from "./MailingEditComponent.vue?vue&type=script&lang=js"
export * from "./MailingEditComponent.vue?vue&type=script&lang=js"

import "./MailingEditComponent.vue?vue&type=style&index=0&id=2e51ae07&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e51ae07"]])

export default __exports__